import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Shield } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CONSENT_KEY = 'sg_cookie_consent';

export default function CookieConsent() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    // Enable personalized ads
    window.adsbygoogle = window.adsbygoogle || [];
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
    // Disable personalized ads — AdSense will show non-personalized ads
    if (window.adsbygoogle) {
      window.adsbygoogle.requestNonPersonalizedAds = 1;
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-[60] p-4 bg-card border-t border-border shadow-xl"
          data-testid="cookie-consent-banner"
        >
          <div className="max-w-lg mx-auto">
            <div className="flex items-start gap-3 mb-3">
              <Shield className="w-5 h-5 text-primary shrink-0 mt-0.5" />
              <div>
                <p className="text-xs font-semibold text-foreground mb-1">
                  {t('cookie_title') || 'Cookies & Privacy'}
                </p>
                <p className="text-[10px] text-muted-foreground leading-relaxed">
                  {t('cookie_message') || 'We use cookies for ads and analytics. You can accept personalized ads or choose non-personalized ads only.'}
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={handleAccept}
                className="flex-1 py-2 rounded-lg bg-primary text-primary-foreground text-xs font-medium"
                data-testid="cookie-accept"
              >
                {t('cookie_accept') || 'Accept'}
              </button>
              <button
                onClick={handleDecline}
                className="flex-1 py-2 rounded-lg border border-border text-xs font-medium text-muted-foreground"
                data-testid="cookie-decline"
              >
                {t('cookie_decline') || 'Non-personalized only'}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
